"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("@optimizely/js-sdk-logging"),
    r = require("@optimizely/js-sdk-event-processor"),
    i = require("@optimizely/js-sdk-utils"),
    n = require("@optimizely/js-sdk-datafile-manager"),
    o = (e = require("murmurhash")) && "object" == _typeof(e) && "default" in e ? e.default : e,
    _s = function s() {
  return (_s = Object.assign || function (e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      for (var n in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function a() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) {
    e += arguments[t].length;
  }

  var i = Array(e),
      n = 0;

  for (t = 0; t < r; t++) {
    for (var o = arguments[t], s = 0, a = o.length; s < a; s++, n++) {
      i[n] = o[s];
    }
  }

  return i;
}

var u = {
  NOTSET: 0,
  DEBUG: 1,
  INFO: 2,
  WARNING: 3,
  ERROR: 4
},
    l = {
  CONDITION_EVALUATOR_ERROR: "%s: Error evaluating audience condition of type %s: %s",
  DATAFILE_AND_SDK_KEY_MISSING: "%s: You must provide at least one of sdkKey or datafile. Cannot start Optimizely",
  EXPERIMENT_KEY_NOT_IN_DATAFILE: "%s: Experiment key %s is not in datafile.",
  FEATURE_NOT_IN_DATAFILE: "%s: Feature key %s is not in datafile.",
  IMPROPERLY_FORMATTED_EXPERIMENT: "%s: Experiment key %s is improperly formatted.",
  INVALID_ATTRIBUTES: "%s: Provided attributes are in an invalid format.",
  INVALID_BUCKETING_ID: "%s: Unable to generate hash for bucketing ID %s: %s",
  INVALID_DATAFILE: "%s: Datafile is invalid - property %s: %s",
  INVALID_DATAFILE_MALFORMED: "%s: Datafile is invalid because it is malformed.",
  INVALID_CONFIG: "%s: Provided Optimizely config is in an invalid format.",
  INVALID_JSON: "%s: JSON object is not valid.",
  INVALID_ERROR_HANDLER: '%s: Provided "errorHandler" is in an invalid format.',
  INVALID_EVENT_DISPATCHER: '%s: Provided "eventDispatcher" is in an invalid format.',
  INVALID_EVENT_TAGS: "%s: Provided event tags are in an invalid format.",
  INVALID_EXPERIMENT_KEY: "%s: Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
  INVALID_EXPERIMENT_ID: "%s: Experiment ID %s is not in datafile.",
  INVALID_GROUP_ID: "%s: Group ID %s is not in datafile.",
  INVALID_LOGGER: '%s: Provided "logger" is in an invalid format.',
  INVALID_ROLLOUT_ID: "%s: Invalid rollout ID %s attached to feature %s",
  INVALID_USER_ID: "%s: Provided user ID is in an invalid format.",
  INVALID_USER_PROFILE_SERVICE: "%s: Provided user profile service instance is in an invalid format: %s.",
  NO_DATAFILE_SPECIFIED: "%s: No datafile specified. Cannot start optimizely.",
  NO_JSON_PROVIDED: "%s: No JSON object to validate against schema.",
  NO_VARIATION_FOR_EXPERIMENT_KEY: "%s: No variation key %s defined in datafile for experiment %s.",
  UNDEFINED_ATTRIBUTE: "%s: Provided attribute: %s has an undefined value.",
  UNRECOGNIZED_ATTRIBUTE: "%s: Unrecognized attribute %s provided. Pruning before sending event to Optimizely.",
  UNABLE_TO_CAST_VALUE: "%s: Unable to cast value %s to type %s, returning null.",
  USER_NOT_IN_FORCED_VARIATION: "%s: User %s is not in the forced variation map. Cannot remove their forced variation.",
  USER_PROFILE_LOOKUP_ERROR: '%s: Error while looking up user profile for user ID "%s": %s.',
  USER_PROFILE_SAVE_ERROR: '%s: Error while saving user profile for user ID "%s": %s.',
  VARIABLE_KEY_NOT_IN_DATAFILE: '%s: Variable with key "%s" associated with feature with key "%s" is not in datafile.',
  VARIATION_ID_NOT_IN_DATAFILE: "%s: No variation ID %s defined in datafile for experiment %s.",
  VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT: "%s: Variation ID %s is not in the datafile.",
  INVALID_INPUT_FORMAT: "%s: Provided %s is in an invalid format.",
  INVALID_DATAFILE_VERSION: "%s: This version of the JavaScript SDK does not support the given datafile version: %s",
  INVALID_VARIATION_KEY: "%s: Provided variation key is in an invalid format."
},
    E = {
  ACTIVATE_USER: "%s: Activating user %s in experiment %s.",
  DISPATCH_CONVERSION_EVENT: "%s: Dispatching conversion event to URL %s with params %s.",
  DISPATCH_IMPRESSION_EVENT: "%s: Dispatching impression event to URL %s with params %s.",
  DEPRECATED_EVENT_VALUE: "%s: Event value is deprecated in %s call.",
  EVENT_KEY_NOT_FOUND: "%s: Event key %s is not in datafile.",
  EXPERIMENT_NOT_RUNNING: "%s: Experiment %s is not running.",
  FEATURE_ENABLED_FOR_USER: "%s: Feature %s is enabled for user %s.",
  FEATURE_NOT_ENABLED_FOR_USER: "%s: Feature %s is not enabled for user %s.",
  FEATURE_HAS_NO_EXPERIMENTS: "%s: Feature %s is not attached to any experiments.",
  FAILED_TO_PARSE_VALUE: '%s: Failed to parse event value "%s" from event tags.',
  FAILED_TO_PARSE_REVENUE: '%s: Failed to parse revenue value "%s" from event tags.',
  FORCED_BUCKETING_FAILED: "%s: Variation key %s is not in datafile. Not activating user %s.",
  INVALID_OBJECT: "%s: Optimizely object is not valid. Failing %s.",
  INVALID_CLIENT_ENGINE: "%s: Invalid client engine passed: %s. Defaulting to node-sdk.",
  INVALID_DEFAULT_DECIDE_OPTIONS: "%s: Provided default decide options is not an array.",
  INVALID_DECIDE_OPTIONS: "%s: Provided decide options is not an array. Using default decide options.",
  INVALID_VARIATION_ID: "%s: Bucketed into an invalid variation ID. Returning null.",
  NOTIFICATION_LISTENER_EXCEPTION: "%s: Notification listener for (%s) threw exception: %s",
  NO_ROLLOUT_EXISTS: "%s: There is no rollout of feature %s.",
  NOT_ACTIVATING_USER: "%s: Not activating user %s for experiment %s.",
  NOT_TRACKING_USER: "%s: Not tracking user %s.",
  PARSED_REVENUE_VALUE: '%s: Parsed revenue value "%s" from event tags.',
  PARSED_NUMERIC_VALUE: '%s: Parsed event value "%s" from event tags.',
  RETURNING_STORED_VARIATION: '%s: Returning previously activated variation "%s" of experiment "%s" for user "%s" from user profile.',
  ROLLOUT_HAS_NO_EXPERIMENTS: "%s: Rollout of feature %s has no experiments",
  SAVED_VARIATION: '%s: Saved variation "%s" of experiment "%s" for user "%s".',
  SAVED_VARIATION_NOT_FOUND: "%s: User %s was previously bucketed into variation with ID %s for experiment %s, but no matching variation was found.",
  SHOULD_NOT_DISPATCH_ACTIVATE: '%s: Experiment %s is not in "Running" state. Not activating user.',
  SKIPPING_JSON_VALIDATION: "%s: Skipping JSON schema validation.",
  TRACK_EVENT: "%s: Tracking event %s for user %s.",
  UNRECOGNIZED_DECIDE_OPTION: "%s: Unrecognized decide option %s provided.",
  USER_ASSIGNED_TO_EXPERIMENT_BUCKET: "%s: Assigned bucket %s to user with bucketing ID %s.",
  USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is in experiment %s of group %s.",
  USER_BUCKETED_INTO_TARGETING_RULE: "%s: User %s bucketed into targeting rule %s.",
  USER_IN_FEATURE_EXPERIMENT: "%s: User %s is in variation %s of experiment %s on the feature %s.",
  USER_IN_ROLLOUT: "%s: User %s is in rollout of feature %s.",
  USER_BUCKETED_INTO_EVERYONE_TARGETING_RULE: "%s: User %s bucketed into everyone targeting rule.",
  USER_NOT_BUCKETED_INTO_EVERYONE_TARGETING_RULE: "%s: User %s not bucketed into everyone targeting rule due to traffic allocation.",
  USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is not in experiment %s of group %s.",
  USER_NOT_BUCKETED_INTO_ANY_EXPERIMENT_IN_GROUP: "%s: User %s is not in any experiment of group %s.",
  USER_NOT_BUCKETED_INTO_TARGETING_RULE: "%s User %s not bucketed into targeting rule %s due to traffic allocation. Trying everyone rule.",
  USER_NOT_IN_FEATURE_EXPERIMENT: "%s: User %s is not in any experiment on the feature %s.",
  USER_NOT_IN_ROLLOUT: "%s: User %s is not in rollout of feature %s.",
  USER_FORCED_IN_VARIATION: "%s: User %s is forced in variation %s.",
  USER_MAPPED_TO_FORCED_VARIATION: "%s: Set variation %s for experiment %s and user %s in the forced variation map.",
  USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s does not meet conditions for targeting rule %s.",
  USER_MEETS_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s meets conditions for targeting rule %s.",
  USER_HAS_VARIATION: "%s: User %s is in variation %s of experiment %s.",
  USER_HAS_FORCED_VARIATION: "%s: Variation %s is mapped to experiment %s and user %s in the forced variation map.",
  USER_HAS_NO_VARIATION: "%s: User %s is in no variation of experiment %s.",
  USER_HAS_NO_FORCED_VARIATION: "%s: User %s is not in the forced variation map.",
  USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT: "%s: No experiment %s mapped to user %s in the forced variation map.",
  USER_NOT_IN_ANY_EXPERIMENT: "%s: User %s is not in any experiment of group %s.",
  USER_NOT_IN_EXPERIMENT: "%s: User %s does not meet conditions to be in experiment %s.",
  USER_RECEIVED_DEFAULT_VARIABLE_VALUE: '%s: User "%s" is not in any variation or rollout rule. Returning default value for variable "%s" of feature flag "%s".',
  FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Feature "%s" is not enabled for user %s. Returning the default variable value "%s".',
  VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Variable "%s" is not used in variation "%s". Returning default value.',
  USER_RECEIVED_VARIABLE_VALUE: '%s: Got variable value "%s" for variable "%s" of feature flag "%s"',
  VALID_DATAFILE: "%s: Datafile is valid.",
  VALID_USER_PROFILE_SERVICE: "%s: Valid user profile service provided.",
  VARIATION_REMOVED_FOR_USER: "%s: Variation mapped to experiment %s has been removed for user %s.",
  VARIABLE_REQUESTED_WITH_WRONG_TYPE: '%s: Requested variable type "%s", but variable is of type "%s". Use correct API to retrieve value. Returning None.',
  VALID_BUCKETING_ID: '%s: BucketingId is valid: "%s"',
  BUCKETING_ID_NOT_STRING: "%s: BucketingID attribute is not a string. Defaulted to userId",
  EVALUATING_AUDIENCE: '%s: Starting to evaluate audience "%s" with conditions: %s.',
  EVALUATING_AUDIENCES_COMBINED: '%s: Evaluating audiences for %s "%s": %s.',
  AUDIENCE_EVALUATION_RESULT: '%s: Audience "%s" evaluated to %s.',
  AUDIENCE_EVALUATION_RESULT_COMBINED: "%s: Audiences for %s %s collectively evaluated to %s.",
  MISSING_ATTRIBUTE_VALUE: '%s: Audience condition %s evaluated to UNKNOWN because no value was passed for user attribute "%s".',
  UNEXPECTED_CONDITION_VALUE: "%s: Audience condition %s evaluated to UNKNOWN because the condition value is not supported.",
  UNEXPECTED_TYPE: '%s: Audience condition %s evaluated to UNKNOWN because a value of type "%s" was passed for user attribute "%s".',
  UNEXPECTED_TYPE_NULL: '%s: Audience condition %s evaluated to UNKNOWN because a null value was passed for user attribute "%s".',
  UNKNOWN_CONDITION_TYPE: "%s: Audience condition %s has an unknown condition type. You may need to upgrade to a newer release of the Optimizely SDK.",
  UNKNOWN_MATCH_TYPE: "%s: Audience condition %s uses an unknown match type. You may need to upgrade to a newer release of the Optimizely SDK.",
  UPDATED_OPTIMIZELY_CONFIG: "%s: Updated Optimizely config to revision %s (project id %s)",
  OUT_OF_BOUNDS: '%s: Audience condition %s evaluated to UNKNOWN because the number value for user attribute "%s" is not in the range [-2^53, +2^53].',
  UNABLE_TO_ATTACH_UNLOAD: '%s: unable to bind optimizely.close() to page unload event: "%s"'
},
    f = {
  REVENUE: "revenue",
  VALUE: "value"
},
    p = {
  BOT_FILTERING: "$opt_bot_filtering",
  BUCKETING_ID: "$opt_bucketing_id",
  STICKY_BUCKETING_KEY: "$opt_experiment_bucket_map",
  USER_AGENT: "$opt_user_agent"
},
    I = ["node-sdk", "react-sdk", "javascript-sdk"],
    _ = i.NOTIFICATION_TYPES,
    g = {
  AB_TEST: "ab-test",
  FEATURE: "feature",
  FEATURE_TEST: "feature-test",
  FEATURE_VARIABLE: "feature-variable",
  ALL_FEATURE_VARIABLES: "all-feature-variables",
  FLAG: "flag"
},
    c = {
  FEATURE_TEST: "feature-test",
  ROLLOUT: "rollout",
  EXPERIMENT: "experiment"
},
    d = {
  RULE: "rule",
  EXPERIMENT: "experiment"
},
    O = {
  BOOLEAN: "boolean",
  DOUBLE: "double",
  INTEGER: "integer",
  STRING: "string",
  JSON: "json"
},
    N = {
  V2: "2",
  V3: "3",
  V4: "4"
},
    R = {
  SDK_NOT_READY: "Optimizely SDK not configured properly yet.",
  FLAG_KEY_INVALID: 'No flag was found for key "%s".',
  VARIABLE_VALUE_INVALID: 'Variable value for key "%s" is invalid or wrong type.'
},
    v = Object.freeze({
  __proto__: null,
  LOG_LEVEL: u,
  ERROR_MESSAGES: l,
  LOG_MESSAGES: E,
  RESERVED_EVENT_KEYWORDS: f,
  CONTROL_ATTRIBUTES: p,
  JAVASCRIPT_CLIENT_ENGINE: "javascript-sdk",
  NODE_CLIENT_ENGINE: "node-sdk",
  REACT_CLIENT_ENGINE: "react-sdk",
  NODE_CLIENT_VERSION: "4.5.1",
  VALID_CLIENT_ENGINES: I,
  NOTIFICATION_TYPES: _,
  DECISION_NOTIFICATION_TYPES: g,
  DECISION_SOURCES: c,
  AUDIENCE_EVALUATION_TYPES: d,
  FEATURE_VARIABLE_TYPES: O,
  DATAFILE_VERSIONS: N,
  DECISION_MESSAGES: R
}),
    h = "CONFIG_VALIDATOR",
    T = [N.V2, N.V3, N.V4],
    y = function y(e) {
  if ("object" == _typeof(e) && null !== e) {
    var t = e,
        r = t.errorHandler,
        n = t.eventDispatcher,
        o = t.logger;
    if (r && "function" != typeof r.handleError) throw new Error(i.sprintf(l.INVALID_ERROR_HANDLER, h));
    if (n && "function" != typeof n.dispatchEvent) throw new Error(i.sprintf(l.INVALID_EVENT_DISPATCHER, h));
    if (o && "function" != typeof o.log) throw new Error(i.sprintf(l.INVALID_LOGGER, h));
    return !0;
  }

  throw new Error(i.sprintf(l.INVALID_CONFIG, h));
},
    A = function A(e) {
  if (!e) throw new Error(i.sprintf(l.NO_DATAFILE_SPECIFIED, h));
  if ("string" == typeof e) try {
    e = JSON.parse(e);
  } catch (e) {
    throw new Error(i.sprintf(l.INVALID_DATAFILE_MALFORMED, h));
  }
  if ("object" == _typeof(e) && !Array.isArray(e) && null !== e && -1 === T.indexOf(e.version)) throw new Error(i.sprintf(l.INVALID_DATAFILE_VERSION, h, e.version));
  return e;
},
    U = {
  handleError: function handleError() {}
},
    L = function L(e) {
  return Object.keys(e).map(function (t) {
    return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
  }).join("&");
},
    D = {
  dispatchEvent: function dispatchEvent(e, t) {
    var r,
        i = e.url,
        n = e.params;
    "POST" === e.httpVerb ? ((r = new XMLHttpRequest()).open("POST", i, !0), r.setRequestHeader("Content-Type", "application/json"), r.onreadystatechange = function () {
      if (4 === r.readyState && t && "function" == typeof t) try {
        t({
          statusCode: r.status
        });
      } catch (e) {}
    }, r.send(JSON.stringify(n))) : (i += "?wxhr=true", n && (i += "&" + L(n)), (r = new XMLHttpRequest()).open("GET", i, !0), r.onreadystatechange = function () {
      if (4 === r.readyState && t && "function" == typeof t) try {
        t();
      } catch (e) {}
    }, r.send());
  }
};

function S() {}

S.prototype.log = function () {};

var m,
    V = {
  createLogger: function createLogger(e) {
    return new t.ConsoleLogHandler(e);
  },
  createNoOpLogger: function createNoOpLogger() {
    return new S();
  }
};

function C(e, t, r) {
  return {
    variationKey: null,
    enabled: !1,
    variables: {},
    ruleKey: null,
    flagKey: e,
    userContext: t,
    reasons: r
  };
}

(m = exports.OptimizelyDecideOption || (exports.OptimizelyDecideOption = {})).DISABLE_DECISION_EVENT = "DISABLE_DECISION_EVENT", m.ENABLED_FLAGS_ONLY = "ENABLED_FLAGS_ONLY", m.IGNORE_USER_PROFILE_SERVICE = "IGNORE_USER_PROFILE_SERVICE", m.INCLUDE_REASONS = "INCLUDE_REASONS", m.EXCLUDE_VARIABLES = "EXCLUDE_VARIABLES";

var P = function () {
  function e(e) {
    var t,
        r = e.optimizely,
        i = e.userId,
        n = e.attributes;
    this.optimizely = r, this.userId = i, this.attributes = null !== (t = _s({}, n)) && void 0 !== t ? t : {};
  }

  return e.prototype.setAttribute = function (e, t) {
    this.attributes[e] = t;
  }, e.prototype.getUserId = function () {
    return this.userId;
  }, e.prototype.getAttributes = function () {
    return _s({}, this.attributes);
  }, e.prototype.getOptimizely = function () {
    return this.optimizely;
  }, e.prototype.decide = function (e, t) {
    return void 0 === t && (t = []), this.optimizely.decide(this.cloneUserContext(), e, t);
  }, e.prototype.decideForKeys = function (e, t) {
    return void 0 === t && (t = []), this.optimizely.decideForKeys(this.cloneUserContext(), e, t);
  }, e.prototype.decideAll = function (e) {
    return void 0 === e && (e = []), this.optimizely.decideAll(this.cloneUserContext(), e);
  }, e.prototype.trackEvent = function (e, t) {
    this.optimizely.track(e, this.userId, this.attributes, t);
  }, e.prototype.cloneUserContext = function () {
    return new e({
      optimizely: this.getOptimizely(),
      userId: this.getUserId(),
      attributes: this.getAttributes()
    });
  }, e;
}(),
    b = Math.pow(2, 53);

var F = {
  assign: function assign(e) {
    for (var t = [], r = 1; r < arguments.length; r++) {
      t[r - 1] = arguments[r];
    }

    if (!e) return {};
    if ("function" == typeof Object.assign) return Object.assign.apply(Object, a([e], t));

    for (var i = Object(e), n = 0; n < t.length; n++) {
      var o = t[n];
      if (null != o) for (var s in o) {
        Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
      }
    }

    return i;
  },
  currentTimestamp: function currentTimestamp() {
    return Math.round(new Date().getTime());
  },
  isSafeInteger: function isSafeInteger(e) {
    return "number" == typeof e && Math.abs(e) <= b;
  },
  keyBy: function keyBy(e, t) {
    return e ? i.keyBy(e, function (e) {
      return e[t];
    }) : {};
  },
  uuid: i.generateUUID,
  isNumber: function isNumber(e) {
    return "number" == typeof e;
  }
},
    M = "PROJECT_CONFIG";

var k = function k(e, t) {
  void 0 === t && (t = null);
  var r,
      n,
      o = (r = e, (n = F.assign({}, r)).audiences = (r.audiences || []).map(function (e) {
    return F.assign({}, e);
  }), n.experiments = (r.experiments || []).map(function (e) {
    return F.assign({}, e);
  }), n.featureFlags = (r.featureFlags || []).map(function (e) {
    return F.assign({}, e);
  }), n.groups = (r.groups || []).map(function (e) {
    var t = F.assign({}, e);
    return t.experiments = (e.experiments || []).map(function (e) {
      return F.assign({}, e);
    }), t;
  }), n.rollouts = (r.rollouts || []).map(function (e) {
    var t = F.assign({}, e);
    return t.experiments = (e.experiments || []).map(function (e) {
      return F.assign({}, e);
    }), t;
  }), n);
  return o.__datafileStr = null === t ? JSON.stringify(e) : t, (o.audiences || []).forEach(function (e) {
    e.conditions = JSON.parse(e.conditions);
  }), o.audiencesById = F.keyBy(o.audiences, "id"), F.assign(o.audiencesById, F.keyBy(o.typedAudiences, "id")), o.attributeKeyMap = F.keyBy(o.attributes, "key"), o.eventKeyMap = F.keyBy(o.events, "key"), o.groupIdMap = F.keyBy(o.groups, "id"), Object.keys(o.groupIdMap || {}).forEach(function (e) {
    (o.groupIdMap[e].experiments || []).forEach(function (t) {
      o.experiments.push(F.assign(t, {
        groupId: e
      }));
    });
  }), o.rolloutIdMap = F.keyBy(o.rollouts || [], "id"), i.objectValues(o.rolloutIdMap || {}).forEach(function (e) {
    (e.experiments || []).forEach(function (e) {
      o.experiments.push(e), e.variationKeyMap = F.keyBy(e.variations, "key");
    });
  }), o.experimentKeyMap = F.keyBy(o.experiments, "key"), o.experimentIdMap = F.keyBy(o.experiments, "id"), o.variationIdMap = {}, o.variationVariableUsageMap = {}, (o.experiments || []).forEach(function (e) {
    e.variationKeyMap = F.keyBy(e.variations, "key"), F.assign(o.variationIdMap, F.keyBy(e.variations, "id")), i.objectValues(e.variationKeyMap || {}).forEach(function (e) {
      e.variables && (o.variationVariableUsageMap[e.id] = F.keyBy(e.variables, "id"));
    });
  }), o.experimentFeatureMap = {}, o.featureKeyMap = F.keyBy(o.featureFlags || [], "key"), i.objectValues(o.featureKeyMap || {}).forEach(function (e) {
    e.variables.forEach(function (e) {
      e.type === O.STRING && e.subType === O.JSON && (e.type = O.JSON, delete e.subType);
    }), e.variableKeyMap = F.keyBy(e.variables, "key"), (e.experimentIds || []).forEach(function (t) {
      o.experimentFeatureMap[t] ? o.experimentFeatureMap[t].push(e.id) : o.experimentFeatureMap[t] = [e.id];
      var r = o.experimentIdMap[t];
      r.groupId && !e.groupId && (e.groupId = r.groupId);
    });
  }), o;
},
    B = function B(e, t) {
  var r = e.experimentKeyMap[t];
  if (!r) throw new Error(i.sprintf(l.INVALID_EXPERIMENT_KEY, M, t));
  return r.id;
},
    x = function x(e, t) {
  var r = e.experimentKeyMap[t];
  if (!r) throw new Error(i.sprintf(l.INVALID_EXPERIMENT_KEY, M, t));
  return r.status;
},
    K = function K(e, t) {
  return "Running" === x(e, t);
},
    G = function G(e, t, r) {
  var i = e.experimentKeyMap[t];
  return i.variationKeyMap.hasOwnProperty(r) ? i.variationKeyMap[r].id : null;
},
    w = function w(e, t) {
  if (e.experimentKeyMap.hasOwnProperty(t)) {
    var r = e.experimentKeyMap[t];
    if (r) return r;
  }

  throw new Error(i.sprintf(l.EXPERIMENT_KEY_NOT_IN_DATAFILE, M, t));
},
    j = function j(e, t, r) {
  if (e.featureKeyMap.hasOwnProperty(t)) {
    var n = e.featureKeyMap[t];
    if (n) return n;
  }

  return r.log(u.ERROR, i.sprintf(l.FEATURE_NOT_IN_DATAFILE, M, t)), null;
},
    Y = function Y(e, t, r, n) {
  var o = e.featureKeyMap[t];
  if (!o) return n.log(u.ERROR, i.sprintf(l.FEATURE_NOT_IN_DATAFILE, M, t)), null;
  var s = o.variableKeyMap[r];
  return s || (n.log(u.ERROR, i.sprintf(l.VARIABLE_KEY_NOT_IN_DATAFILE, M, r, t)), null);
},
    H = function H(e, t, r, n) {
  if (!t || !r) return null;
  if (!e.variationVariableUsageMap.hasOwnProperty(r.id)) return n.log(u.ERROR, i.sprintf(l.VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT, M, r.id)), null;
  var o = e.variationVariableUsageMap[r.id][t.id];
  return o ? o.value : null;
},
    X = function X(e, t, r) {
  var n;

  switch (t) {
    case O.BOOLEAN:
      "true" !== e && "false" !== e ? (r.log(u.ERROR, i.sprintf(l.UNABLE_TO_CAST_VALUE, M, e, t)), n = null) : n = "true" === e;
      break;

    case O.INTEGER:
      n = parseInt(e, 10), isNaN(n) && (r.log(u.ERROR, i.sprintf(l.UNABLE_TO_CAST_VALUE, M, e, t)), n = null);
      break;

    case O.DOUBLE:
      n = parseFloat(e), isNaN(n) && (r.log(u.ERROR, i.sprintf(l.UNABLE_TO_CAST_VALUE, M, e, t)), n = null);
      break;

    case O.JSON:
      try {
        n = JSON.parse(e);
      } catch (o) {
        r.log(u.ERROR, i.sprintf(l.UNABLE_TO_CAST_VALUE, M, e, t)), n = null;
      }

      break;

    default:
      n = e;
  }

  return n;
},
    z = function z(e, t) {
  return e.eventKeyMap.hasOwnProperty(t);
},
    J = function J(e, t) {
  return e.experimentFeatureMap.hasOwnProperty(t);
},
    Z = function Z(e) {
  return !!e.sendFlagDecisions;
},
    W = B,
    q = function q(e, t) {
  var r = e.experimentIdMap[t];
  if (!r) throw new Error(i.sprintf(l.INVALID_EXPERIMENT_ID, M, t));
  return r.layerId;
},
    $ = function $(e, t, r) {
  var n = e.attributeKeyMap[t],
      o = 0 === t.indexOf("$opt_");
  return n ? (o && r.log(u.WARN, i.sprintf("Attribute %s unexpectedly has reserved prefix %s; using attribute ID instead of reserved attribute name.", t, "$opt_")), n.id) : o ? t : (r.log(u.DEBUG, i.sprintf(l.UNRECOGNIZED_ATTRIBUTE, M, t)), null);
},
    Q = function Q(e, t) {
  var r = e.eventKeyMap[t];
  return r ? r.id : null;
},
    ee = function ee(e, t) {
  return "Running" === x(e, t);
},
    te = function te(e, t) {
  var r = e.experimentKeyMap[t];
  if (!r) throw new Error(i.sprintf(l.INVALID_EXPERIMENT_KEY, M, t));
  return r.audienceConditions || r.audienceIds;
},
    re = function re(e, t) {
  return e.variationIdMap.hasOwnProperty(t) ? e.variationIdMap[t].key : null;
},
    ie = G,
    ne = w,
    oe = function oe(e, t) {
  var r = e.experimentKeyMap[t];
  if (!r) throw new Error(i.sprintf(l.INVALID_EXPERIMENT_KEY, M, t));
  return r.trafficAllocation;
},
    se = function se(e, t, r) {
  if (e.experimentIdMap.hasOwnProperty(t)) {
    var n = e.experimentIdMap[t];
    if (n) return n;
  }

  return r.log(u.ERROR, i.sprintf(l.INVALID_EXPERIMENT_ID, M, t)), null;
},
    ae = function ae(e) {
  return e.audiencesById;
},
    ue = function ue(e) {
  return e.__datafileStr;
},
    le = function le(e) {
  var t;

  try {
    t = A(e.datafile);
  } catch (e) {
    return {
      configObj: null,
      error: e
    };
  }

  if (e.jsonSchemaValidator) try {
    e.jsonSchemaValidator.validate(t), e.logger.log(u.INFO, i.sprintf(E.VALID_DATAFILE, M));
  } catch (e) {
    return {
      configObj: null,
      error: e
    };
  } else e.logger.log(u.INFO, i.sprintf(E.SKIPPING_JSON_VALIDATION, M));
  var r = [t];
  return "string" == typeof e.datafile && r.push(e.datafile), {
    configObj: k.apply(void 0, r),
    error: null
  };
},
    Ee = function () {
  function e(t, r) {
    this.experimentsMap = e.getExperimentsMap(t), this.featuresMap = e.getFeaturesMap(t, this.experimentsMap), this.revision = t.revision, this.datafile = r;
  }

  return e.prototype.getDatafile = function () {
    return this.datafile;
  }, e.getRolloutExperimentIds = function (e) {
    return (e || []).reduce(function (e, t) {
      return t.experiments.forEach(function (t) {
        e[t.id] = !0;
      }), e;
    }, {});
  }, e.getExperimentsMap = function (e) {
    var t = this,
        r = this.getRolloutExperimentIds(e.rollouts),
        i = (e.featureFlags || []).reduce(function (e, t) {
      return e[t.id] = t.variables, e;
    }, {});
    return (e.experiments || []).reduce(function (n, o) {
      return r[o.id] || (n[o.key] = {
        id: o.id,
        key: o.key,
        variationsMap: (o.variations || []).reduce(function (r, n) {
          return r[n.key] = {
            id: n.id,
            key: n.key,
            variablesMap: t.getMergedVariablesMap(e, n, o.id, i)
          }, J(e, o.id) && (r[n.key].featureEnabled = n.featureEnabled), r;
        }, {})
      }), n;
    }, {});
  }, e.getMergedVariablesMap = function (e, t, r, i) {
    var n = e.experimentFeatureMap[r],
        o = {};

    if (n) {
      var s = i[n.toString()],
          a = (t.variables || []).reduce(function (e, t) {
        return e[t.id] = {
          id: t.id,
          value: t.value
        }, e;
      }, {});
      o = (s || []).reduce(function (e, r) {
        var i = a[r.id],
            n = t.featureEnabled && i ? i.value : r.defaultValue;
        return e[r.key] = {
          id: r.id,
          key: r.key,
          type: r.type,
          value: n
        }, e;
      }, {});
    }

    return o;
  }, e.getFeaturesMap = function (e, t) {
    return (e.featureFlags || []).reduce(function (r, i) {
      return r[i.key] = {
        id: i.id,
        key: i.key,
        experimentsMap: (i.experimentIds || []).reduce(function (r, i) {
          var n = e.experimentIdMap[i].key;
          return r[n] = t[n], r;
        }, {}),
        variablesMap: (i.variables || []).reduce(function (e, t) {
          return e[t.key] = {
            id: t.id,
            key: t.key,
            type: t.type,
            value: t.defaultValue
          }, e;
        }, {})
      }, r;
    }, {});
  }, e;
}();

var fe = t.getLogger();

function pe(e, t) {
  return e instanceof Error ? e.message : t || "Unknown error";
}

function Ie(e) {
  try {
    this.__initialize(e);
  } catch (e) {
    fe.error(e), this.__updateListeners = [], this.__configObj = null, this.__optimizelyConfigObj = null, this.__readyPromise = Promise.resolve({
      success: !1,
      reason: pe(e, "Error in initialize")
    });
  }
}

Ie.prototype.__initialize = function (e) {
  if (this.__updateListeners = [], this.jsonSchemaValidator = e.jsonSchemaValidator, !e.datafile && !e.sdkKey) {
    this.__configObj = null;
    var t = new Error(i.sprintf(l.DATAFILE_AND_SDK_KEY_MISSING, "PROJECT_CONFIG_MANAGER"));
    return this.__readyPromise = Promise.resolve({
      success: !1,
      reason: pe(t)
    }), void fe.error(t);
  }

  var r;

  if (e.datafile ? (r = this.__handleNewDatafile(e.datafile)) && (this.__configObj = null) : this.__configObj = null, e.sdkKey) {
    var o = {
      sdkKey: e.sdkKey
    };
    this.__validateDatafileOptions(e.datafileOptions) && F.assign(o, e.datafileOptions), this.__configObj && (o.datafile = ue(this.__configObj)), this.datafileManager = new n.HttpPollingDatafileManager(o), this.datafileManager.start(), this.__readyPromise = this.datafileManager.onReady().then(this.__onDatafileManagerReadyFulfill.bind(this), this.__onDatafileManagerReadyReject.bind(this)), this.datafileManager.on("update", this.__onDatafileManagerUpdate.bind(this));
  } else this.__configObj ? this.__readyPromise = Promise.resolve({
    success: !0
  }) : this.__readyPromise = Promise.resolve({
    success: !1,
    reason: pe(r, "Invalid datafile")
  });
}, Ie.prototype.__onDatafileManagerReadyFulfill = function () {
  var e = this.__handleNewDatafile(this.datafileManager.get());

  return e ? {
    success: !1,
    reason: pe(e)
  } : {
    success: !0
  };
}, Ie.prototype.__onDatafileManagerReadyReject = function (e) {
  return {
    success: !1,
    reason: pe(e, "Failed to become ready")
  };
}, Ie.prototype.__onDatafileManagerUpdate = function () {
  this.__handleNewDatafile(this.datafileManager.get());
}, Ie.prototype.__validateDatafileOptions = function (e) {
  return void 0 === e || "object" == _typeof(e) && null !== e;
}, Ie.prototype.__handleNewDatafile = function (e) {
  var t = le({
    datafile: e,
    jsonSchemaValidator: this.jsonSchemaValidator,
    logger: fe
  }),
      r = t.configObj,
      i = t.error;
  i ? fe.error(i) : (this.__configObj ? this.__configObj.revision : "null") !== r.revision && (this.__configObj = r, this.__optimizelyConfigObj = function (e, t) {
    return new Ee(e, t);
  }(this.__configObj, ue(this.__configObj)), this.__updateListeners.forEach(function (e) {
    e(r);
  }));
  return i;
}, Ie.prototype.getConfig = function () {
  return this.__configObj;
}, Ie.prototype.getOptimizelyConfig = function () {
  return this.__optimizelyConfigObj;
}, Ie.prototype.onReady = function () {
  return this.__readyPromise;
}, Ie.prototype.onUpdate = function (e) {
  return this.__updateListeners.push(e), function () {
    var t = this.__updateListeners.indexOf(e);

    t > -1 && this.__updateListeners.splice(t, 1);
  }.bind(this);
}, Ie.prototype.stop = function () {
  this.datafileManager && this.datafileManager.stop(), this.__updateListeners = [];
};

var _e = function () {
  function e(e) {
    var t = this;
    this.logger = e.logger, this.errorHandler = e.errorHandler, this.notificationListeners = {}, i.objectValues(_).forEach(function (e) {
      t.notificationListeners[e] = [];
    }), this.listenerId = 1;
  }

  return e.prototype.addNotificationListener = function (e, t) {
    try {
      if (!(i.objectValues(_).indexOf(e) > -1)) return -1;
      this.notificationListeners[e] || (this.notificationListeners[e] = []);
      var r = !1;
      if ((this.notificationListeners[e] || []).forEach(function (e) {
        e.callback !== t || (r = !0);
      }), r) return -1;
      this.notificationListeners[e].push({
        id: this.listenerId,
        callback: t
      });
      var n = this.listenerId;
      return this.listenerId += 1, n;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), -1;
    }
  }, e.prototype.removeNotificationListener = function (e) {
    var t = this;

    try {
      var r, i;
      if (Object.keys(this.notificationListeners).some(function (n) {
        return (t.notificationListeners[n] || []).every(function (t, o) {
          return t.id !== e || (r = o, i = n, !1);
        }), void 0 !== r && void 0 !== i;
      }), void 0 !== r && void 0 !== i) return this.notificationListeners[i].splice(r, 1), !0;
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
    }

    return !1;
  }, e.prototype.clearAllNotificationListeners = function () {
    var e = this;

    try {
      i.objectValues(_).forEach(function (t) {
        e.notificationListeners[t] = [];
      });
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
    }
  }, e.prototype.clearNotificationListeners = function (e) {
    try {
      this.notificationListeners[e] = [];
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
    }
  }, e.prototype.sendNotifications = function (e, t) {
    var r = this;

    try {
      (this.notificationListeners[e] || []).forEach(function (n) {
        var o = n.callback;

        try {
          o(t);
        } catch (t) {
          r.logger.log(u.ERROR, i.sprintf(E.NOTIFICATION_LISTENER_EXCEPTION, "NOTIFICATION_CENTER", e, t.message));
        }
      });
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
    }
  }, e;
}();

var ge = Math.pow(2, 32),
    ce = function ce(e, t, r, n) {
  var o = i.sprintf("%s%s", t, e.id),
      s = Oe(o);
  n.log(u.DEBUG, i.sprintf(E.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", s, r));
  var a = e.trafficAllocation;
  return de(s, a);
},
    de = function de(e, t) {
  for (var r = 0; r < t.length; r++) {
    if (e < t[r].endOfRange) return t[r].entityId;
  }

  return null;
},
    Oe = function Oe(e) {
  try {
    var t = o.v3(e, 1) / ge;
    return Math.floor(1e4 * t);
  } catch (t) {
    throw new Error(i.sprintf(l.INVALID_BUCKETING_ID, "BUCKETER", e, t.message));
  }
},
    Ne = {
  bucket: function bucket(e) {
    var t = [],
        r = e.experimentKeyMap[e.experimentKey].groupId;

    if (r) {
      var n = e.groupIdMap[r];
      if (!n) throw new Error(i.sprintf(l.INVALID_GROUP_ID, "BUCKETER", r));

      if ("random" === n.policy) {
        var o = ce(n, e.bucketingId, e.userId, e.logger);

        if (null === o) {
          var s = i.sprintf(E.USER_NOT_IN_ANY_EXPERIMENT, "BUCKETER", e.userId, r);
          return e.logger.log(u.INFO, s), t.push(s), {
            result: null,
            reasons: t
          };
        }

        if (o !== e.experimentId) {
          var a = i.sprintf(E.USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r);
          return e.logger.log(u.INFO, a), t.push(a), {
            result: null,
            reasons: t
          };
        }

        var f = i.sprintf(E.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r);
        e.logger.log(u.INFO, f), t.push(f);
      }
    }

    var p = i.sprintf("%s%s", e.bucketingId, e.experimentId),
        I = Oe(p),
        _ = i.sprintf(E.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", I, e.userId);

    e.logger.log(u.DEBUG, _), t.push(_);
    var g = de(I, e.trafficAllocationConfig);

    if (null !== g && !e.variationIdMap[g]) {
      if (g) {
        var c = i.sprintf(E.INVALID_VARIATION_ID, "BUCKETER");
        e.logger.log(u.WARNING, c), t.push(c);
      }

      return {
        result: null,
        reasons: t
      };
    }

    return {
      result: g,
      reasons: t
    };
  },
  bucketUserIntoExperiment: ce
},
    Re = ["and", "or", "not"];

function ve(e, t) {
  if (Array.isArray(e)) {
    var r = e[0],
        i = e.slice(1);

    switch ("string" == typeof r && -1 === Re.indexOf(r) && (r = "or", i = e), r) {
      case "and":
        return function (e, t) {
          var r = !1;

          if (Array.isArray(e)) {
            for (var i = 0; i < e.length; i++) {
              var n = ve(e[i], t);
              if (!1 === n) return !1;
              null === n && (r = !0);
            }

            return !r || null;
          }

          return null;
        }(i, t);

      case "not":
        return function (e, t) {
          if (Array.isArray(e) && e.length > 0) {
            var r = ve(e[0], t);
            return null === r ? null : !r;
          }

          return null;
        }(i, t);

      default:
        return function (e, t) {
          var r = !1;

          if (Array.isArray(e)) {
            for (var i = 0; i < e.length; i++) {
              var n = ve(e[i], t);
              if (!0 === n) return !0;
              null === n && (r = !0);
            }

            return !!r && null;
          }

          return null;
        }(i, t);
    }
  }

  return t(e);
}

var he = t.getLogger();

function Te(e) {
  return /^\d+$/.test(e);
}

function ye(e) {
  var t = e.indexOf("-"),
      r = e.indexOf("+");
  return !(t < 0) && (r < 0 || t < r);
}

function Ae(e) {
  var t = e.indexOf("-"),
      r = e.indexOf("+");
  return !(r < 0) && (t < 0 || r < t);
}

function Ue(e) {
  var t = e,
      r = "";
  if (function (e) {
    return /\s/.test(e);
  }(e)) return he.warn(E.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  if (ye(e) ? (t = e.substring(0, e.indexOf("-")), r = e.substring(e.indexOf("-") + 1)) : Ae(e) && (t = e.substring(0, e.indexOf("+")), r = e.substring(e.indexOf("+") + 1)), "string" != typeof t || "string" != typeof r) return null;
  var i = t.split(".").length - 1;
  if (i > 2) return he.warn(E.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  var n = t.split(".");
  if (n.length != i + 1) return he.warn(E.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;

  for (var o = 0, s = n; o < s.length; o++) {
    if (!Te(s[o])) return he.warn(E.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  }

  return r && n.push(r), n;
}

var Le = "CUSTOM_ATTRIBUTE_CONDITION_EVALUATOR",
    De = t.getLogger(),
    Se = ["exact", "exists", "gt", "ge", "lt", "le", "substring", "semver_eq", "semver_lt", "semver_le", "semver_gt", "semver_ge"],
    me = {};

function Ve(e) {
  return "string" == typeof e || "boolean" == typeof e || F.isNumber(e);
}

function Ce(e, t) {
  var r = e.value,
      i = _typeof(r),
      n = e.name,
      o = t[n],
      s = _typeof(o);

  return !Ve(r) || F.isNumber(r) && !F.isSafeInteger(r) ? (De.warn(E.UNEXPECTED_CONDITION_VALUE, Le, JSON.stringify(e)), null) : null === o ? (De.debug(E.UNEXPECTED_TYPE_NULL, Le, JSON.stringify(e), n), null) : Ve(o) && i === s ? F.isNumber(o) && !F.isSafeInteger(o) ? (De.warn(E.OUT_OF_BOUNDS, Le, JSON.stringify(e), n), null) : r === o : (De.warn(E.UNEXPECTED_TYPE, Le, JSON.stringify(e), s, n), null);
}

function Pe(e, t) {
  var r = e.name,
      i = t[r],
      n = _typeof(i),
      o = e.value;

  return null !== o && F.isSafeInteger(o) ? null === i ? (De.debug(E.UNEXPECTED_TYPE_NULL, Le, JSON.stringify(e), r), !1) : F.isNumber(i) ? !!F.isSafeInteger(i) || (De.warn(E.OUT_OF_BOUNDS, Le, JSON.stringify(e), r), !1) : (De.warn(E.UNEXPECTED_TYPE, Le, JSON.stringify(e), n, r), !1) : (De.warn(E.UNEXPECTED_CONDITION_VALUE, Le, JSON.stringify(e)), !1);
}

function be(e, t) {
  var r = e.name,
      i = t[r],
      n = _typeof(i),
      o = e.value;

  return "string" != typeof o ? (De.warn(E.UNEXPECTED_CONDITION_VALUE, Le, JSON.stringify(e)), null) : null === i ? (De.debug(E.UNEXPECTED_TYPE_NULL, Le, JSON.stringify(e), r), null) : "string" != typeof i ? (De.warn(E.UNEXPECTED_TYPE, Le, JSON.stringify(e), n, r), null) : function (e, t) {
    var r = Ue(t),
        i = Ue(e);
    if (!r || !i) return null;

    for (var n = r.length, o = 0; o < i.length; o++) {
      if (n <= o) return ye(e) || Ae(e) ? 1 : -1;

      if (Te(r[o])) {
        var s = parseInt(r[o]),
            a = parseInt(i[o]);
        if (s > a) return 1;
        if (s < a) return -1;
      } else {
        if (r[o] < i[o]) return ye(e) && !ye(t) ? 1 : -1;
        if (r[o] > i[o]) return !ye(e) && ye(t) ? -1 : 1;
      }
    }

    return ye(t) && !ye(e) ? -1 : 0;
  }(o, i);
}

me.exact = Ce, me.exists = function (e, t) {
  var r = t[e.name];
  return null != r;
}, me.gt = function (e, t) {
  var r = t[e.name],
      i = e.value;
  if (!Pe(e, t) || null === i) return null;
  return r > i;
}, me.ge = function (e, t) {
  var r = t[e.name],
      i = e.value;
  if (!Pe(e, t) || null === i) return null;
  return r >= i;
}, me.lt = function (e, t) {
  var r = t[e.name],
      i = e.value;
  if (!Pe(e, t) || null === i) return null;
  return r < i;
}, me.le = function (e, t) {
  var r = t[e.name],
      i = e.value;
  if (!Pe(e, t) || null === i) return null;
  return r <= i;
}, me.substring = function (e, t) {
  var r = e.name,
      i = t[e.name],
      n = _typeof(i),
      o = e.value;

  if ("string" != typeof o) return De.warn(E.UNEXPECTED_CONDITION_VALUE, Le, JSON.stringify(e)), null;
  if (null === i) return De.debug(E.UNEXPECTED_TYPE_NULL, Le, JSON.stringify(e), r), null;
  if ("string" != typeof i) return De.warn(E.UNEXPECTED_TYPE, Le, JSON.stringify(e), n, r), null;
  return -1 !== i.indexOf(o);
}, me.semver_eq = function (e, t) {
  var r = be(e, t);
  if (null === r) return null;
  return 0 === r;
}, me.semver_gt = function (e, t) {
  var r = be(e, t);
  if (null === r) return null;
  return r > 0;
}, me.semver_ge = function (e, t) {
  var r = be(e, t);
  if (null === r) return null;
  return r >= 0;
}, me.semver_lt = function (e, t) {
  var r = be(e, t);
  if (null === r) return null;
  return r < 0;
}, me.semver_le = function (e, t) {
  var r = be(e, t);
  if (null === r) return null;
  return r <= 0;
};
var Fe = Object.freeze({
  __proto__: null,
  evaluate: function evaluate(e, t) {
    var r = e.match;
    if (void 0 !== r && -1 === Se.indexOf(r)) return De.warn(E.UNKNOWN_MATCH_TYPE, Le, JSON.stringify(e)), null;
    var i = e.name;
    return t.hasOwnProperty(i) || "exists" == r ? (r && me[r] || Ce)(e, t) : (De.debug(E.MISSING_ATTRIBUTE_VALUE, Le, JSON.stringify(e), i), null);
  }
}),
    Me = t.getLogger();

function ke(e) {
  this.typeToEvaluatorMap = F.assign({}, e, {
    custom_attribute: Fe
  });
}

function Be(e) {
  return "string" == typeof e && "" !== e;
}

ke.prototype.evaluate = function (e, t, r) {
  if (!e || 0 === e.length) return !0;
  r || (r = {});

  var n = function (e) {
    var n = t[e];

    if (n) {
      Me.log(u.DEBUG, i.sprintf(E.EVALUATING_AUDIENCE, "AUDIENCE_EVALUATOR", e, JSON.stringify(n.conditions)));
      var o = ve(n.conditions, this.evaluateConditionWithUserAttributes.bind(this, r)),
          s = null === o ? "UNKNOWN" : o.toString().toUpperCase();
      return Me.log(u.DEBUG, i.sprintf(E.AUDIENCE_EVALUATION_RESULT, "AUDIENCE_EVALUATOR", e, s)), o;
    }

    return null;
  }.bind(this);

  return ve(e, n) || !1;
}, ke.prototype.evaluateConditionWithUserAttributes = function (e, t) {
  var r = this.typeToEvaluatorMap[t.type];
  if (!r) return Me.log(u.WARNING, i.sprintf(E.UNKNOWN_CONDITION_TYPE, "AUDIENCE_EVALUATOR", JSON.stringify(t))), null;

  try {
    return r.evaluate(t, e, Me);
  } catch (e) {
    Me.log(u.ERROR, i.sprintf(l.CONDITION_EVALUATOR_ERROR, "AUDIENCE_EVALUATOR", t.type, e.message));
  }

  return null;
};
var xe = "DECISION_SERVICE",
    Ke = l,
    Ge = u,
    we = E,
    je = c,
    Ye = d;

function He(e) {
  this.audienceEvaluator = new ke(e.UNSTABLE_conditionEvaluators), this.forcedVariationMap = {}, this.logger = e.logger, this.userProfileService = e.userProfileService || null;
}

He.prototype.getVariation = function (e, t, r, n, o) {
  void 0 === o && (o = {});

  var s = this._getBucketingId(r, n),
      a = [];

  if (!this.__checkIfExperimentIsActive(e, t)) {
    var u = i.sprintf(we.EXPERIMENT_NOT_RUNNING, xe, t);
    return this.logger.log(Ge.INFO, u), a.push(u), {
      result: null,
      reasons: a
    };
  }

  var l = e.experimentKeyMap[t],
      E = this.getForcedVariation(e, t, r);
  a.push.apply(a, E.reasons);
  var f = E.result;
  if (f) return {
    result: f,
    reasons: a
  };

  var p = this.__getWhitelistedVariation(l, r);

  a.push.apply(a, p.reasons);
  var I = p.result;
  if (I) return {
    result: I.key,
    reasons: a
  };
  var _ = o[exports.OptimizelyDecideOption.IGNORE_USER_PROFILE_SERVICE];

  if (!_) {
    var g = this.__resolveExperimentBucketMap(r, n);

    if (I = this.__getStoredVariation(e, l, r, g)) {
      var c = i.sprintf(we.RETURNING_STORED_VARIATION, xe, I.key, t, r);
      return this.logger.log(Ge.INFO, c), a.push(c), {
        result: I.key,
        reasons: a
      };
    }
  }

  var d = this.__checkIfUserIsInAudience(e, t, Ye.EXPERIMENT, r, n, "");

  if (a.push.apply(a, d.reasons), !d.result) {
    var O = i.sprintf(we.USER_NOT_IN_EXPERIMENT, xe, r, t);
    return this.logger.log(Ge.INFO, O), a.push(O), {
      result: null,
      reasons: a
    };
  }

  var N = this.__buildBucketerParams(e, t, s, r),
      R = Ne.bucket(N);

  a.push.apply(a, R.reasons);
  var v = R.result;

  if (!(I = e.variationIdMap[v])) {
    var h = i.sprintf(we.USER_HAS_NO_VARIATION, xe, r, t);
    return this.logger.log(Ge.DEBUG, h), a.push(h), {
      result: null,
      reasons: a
    };
  }

  var T = i.sprintf(we.USER_HAS_VARIATION, xe, r, I.key, t);
  return this.logger.log(Ge.INFO, T), a.push(T), _ || this.__saveUserProfile(l, I, r, g), {
    result: I.key,
    reasons: a
  };
}, He.prototype.__resolveExperimentBucketMap = function (e, t) {
  t = t || {};
  var r = this.__getUserProfile(e) || {},
      i = t[p.STICKY_BUCKETING_KEY];
  return F.assign({}, r.experiment_bucket_map, i);
}, He.prototype.__checkIfExperimentIsActive = function (e, t) {
  return ee(e, t);
}, He.prototype.__getWhitelistedVariation = function (e, t) {
  var r = [];

  if (e.forcedVariations && e.forcedVariations.hasOwnProperty(t)) {
    var n = e.forcedVariations[t];

    if (e.variationKeyMap.hasOwnProperty(n)) {
      var o = i.sprintf(we.USER_FORCED_IN_VARIATION, xe, t, n);
      return this.logger.log(Ge.INFO, o), r.push(o), {
        result: e.variationKeyMap[n],
        reasons: r
      };
    }

    var s = i.sprintf(we.FORCED_BUCKETING_FAILED, xe, n, t);
    return this.logger.log(Ge.ERROR, s), r.push(s), {
      result: null,
      reasons: r
    };
  }

  return {
    result: null,
    reasons: r
  };
}, He.prototype.__checkIfUserIsInAudience = function (e, t, r, n, o, s) {
  var a = [],
      u = te(e, t),
      l = ae(e),
      E = i.sprintf(we.EVALUATING_AUDIENCES_COMBINED, xe, r, s || t, JSON.stringify(u));
  this.logger.log(Ge.DEBUG, E), a.push(E);
  var f = this.audienceEvaluator.evaluate(u, l, o),
      p = i.sprintf(we.AUDIENCE_EVALUATION_RESULT_COMBINED, xe, r, s || t, f.toString().toUpperCase());
  return this.logger.log(Ge.INFO, p), a.push(p), {
    result: f,
    reasons: a
  };
}, He.prototype.__buildBucketerParams = function (e, t, r, i) {
  var n = {};
  return n.experimentKey = t, n.experimentId = W(e, t), n.userId = i, n.trafficAllocationConfig = oe(e, t), n.experimentKeyMap = e.experimentKeyMap, n.groupIdMap = e.groupIdMap, n.variationIdMap = e.variationIdMap, n.logger = this.logger, n.bucketingId = r, n;
}, He.prototype.__getStoredVariation = function (e, t, r, n) {
  if (n.hasOwnProperty(t.id)) {
    var o = n[t.id],
        s = o.variation_id;
    if (e.variationIdMap.hasOwnProperty(s)) return e.variationIdMap[o.variation_id];
    this.logger.log(Ge.INFO, i.sprintf(we.SAVED_VARIATION_NOT_FOUND, xe, r, s, t.key));
  }

  return null;
}, He.prototype.__getUserProfile = function (e) {
  var t = {
    user_id: e,
    experiment_bucket_map: {}
  };
  if (!this.userProfileService) return t;

  try {
    return this.userProfileService.lookup(e);
  } catch (t) {
    this.logger.log(Ge.ERROR, i.sprintf(Ke.USER_PROFILE_LOOKUP_ERROR, xe, e, t.message));
  }
}, He.prototype.__saveUserProfile = function (e, t, r, n) {
  if (this.userProfileService) try {
    n[e.id] = {
      variation_id: t.id
    }, this.userProfileService.save({
      user_id: r,
      experiment_bucket_map: n
    }), this.logger.log(Ge.INFO, i.sprintf(we.SAVED_VARIATION, xe, t.key, e.key, r));
  } catch (e) {
    this.logger.log(Ge.ERROR, i.sprintf(Ke.USER_PROFILE_SAVE_ERROR, xe, r, e.message));
  }
}, He.prototype.getVariationForFeature = function (e, t, r, n, o) {
  void 0 === o && (o = {});

  var s = [],
      a = this._getVariationForFeatureExperiment(e, t, r, n, o);

  s.push.apply(s, a.reasons);
  var u = a.result;
  if (null !== u.variation) return {
    result: u,
    reasons: s
  };

  var l = this._getVariationForRollout(e, t, r, n);

  s.push.apply(s, l.reasons);
  var E = l.result;

  if (null !== E.variation) {
    var f = i.sprintf(we.USER_IN_ROLLOUT, xe, r, t.key);
    return this.logger.log(Ge.DEBUG, f), s.push(f), {
      result: E,
      reasons: s
    };
  }

  var p = i.sprintf(we.USER_NOT_IN_ROLLOUT, xe, r, t.key);
  return this.logger.log(Ge.DEBUG, p), s.push(p), {
    result: E,
    reasons: s
  };
}, He.prototype._getVariationForFeatureExperiment = function (e, t, r, n, o) {
  void 0 === o && (o = {});
  var s,
      a = [],
      u = null,
      l = null;

  if (t.hasOwnProperty("groupId")) {
    var E = e.groupIdMap[t.groupId];
    E && (u = this._getExperimentInGroup(e, E, r)) && -1 !== t.experimentIds.indexOf(u.id) && (s = this.getVariation(e, u.key, r, n, o), a.push.apply(a, s.reasons), l = s.result);
  } else if (t.experimentIds.length > 0) (u = se(e, t.experimentIds[0], this.logger)) && (s = this.getVariation(e, u.key, r, n, o), a.push.apply(a, s.reasons), l = s.result);else {
    var f = i.sprintf(we.FEATURE_HAS_NO_EXPERIMENTS, xe, t.key);
    this.logger.log(Ge.DEBUG, f), a.push(f);
  }

  var p = null;
  return null !== l && null !== u && (p = u.variationKeyMap[l]), {
    result: {
      experiment: u,
      variation: p,
      decisionSource: je.FEATURE_TEST
    },
    reasons: a
  };
}, He.prototype._getExperimentInGroup = function (e, t, r) {
  var n = Ne.bucketUserIntoExperiment(t, r, r, this.logger);

  if (n) {
    this.logger.log(Ge.INFO, i.sprintf(we.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP, xe, r, n, t.id));
    var o = se(e, n, this.logger);
    if (o) return o;
  }

  return this.logger.log(Ge.INFO, i.sprintf(we.USER_NOT_BUCKETED_INTO_ANY_EXPERIMENT_IN_GROUP, xe, r, t.id)), null;
}, He.prototype._getVariationForRollout = function (e, t, r, n) {
  var o = [];

  if (!t.rolloutId) {
    var s = i.sprintf(we.NO_ROLLOUT_EXISTS, xe, t.key);
    return this.logger.log(Ge.DEBUG, s), o.push(s), {
      result: {
        experiment: null,
        variation: null,
        decisionSource: je.ROLLOUT
      },
      reasons: o
    };
  }

  var a = e.rolloutIdMap[t.rolloutId];

  if (!a) {
    var u = i.sprintf(Ke.INVALID_ROLLOUT_ID, xe, t.rolloutId, t.key);
    return this.logger.log(Ge.ERROR, u), o.push(u), {
      result: {
        experiment: null,
        variation: null,
        decisionSource: je.ROLLOUT
      },
      reasons: o
    };
  }

  if (0 === a.experiments.length) {
    var l = i.sprintf(we.ROLLOUT_HAS_NO_EXPERIMENTS, xe, t.rolloutId);
    return this.logger.log(Ge.ERROR, l), o.push(l), {
      result: {
        experiment: null,
        variation: null,
        decisionSource: je.ROLLOUT
      },
      reasons: o
    };
  }

  var E,
      f,
      p,
      I,
      _,
      g,
      c,
      d,
      O = this._getBucketingId(r, n),
      N = a.experiments.length - 1;

  for (E = 0; E < N; E++) {
    if (f = e.experimentKeyMap[a.experiments[E].key], g = E + 1, d = this.__checkIfUserIsInAudience(e, f.key, Ye.RULE, r, n, g), o.push.apply(o, d.reasons), d.result) {
      var R = i.sprintf(we.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE, xe, r, g);

      if (this.logger.log(Ge.DEBUG, R), o.push(R), p = this.__buildBucketerParams(e, f.key, O, r), c = Ne.bucket(p), o.push.apply(o, c.reasons), I = c.result, _ = e.variationIdMap[I]) {
        var v = i.sprintf(we.USER_BUCKETED_INTO_TARGETING_RULE, xe, r, g);
        return this.logger.log(Ge.DEBUG, v), o.push(v), {
          result: {
            experiment: f,
            variation: _,
            decisionSource: je.ROLLOUT
          },
          reasons: o
        };
      }

      var h = i.sprintf(we.USER_NOT_BUCKETED_INTO_TARGETING_RULE, xe, r, g);
      this.logger.log(Ge.DEBUG, h), o.push(h);
      break;
    }

    var T = i.sprintf(we.USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE, xe, r, g);
    this.logger.log(Ge.DEBUG, T), o.push(T);
  }

  var y = e.experimentKeyMap[a.experiments[N].key],
      A = this.__checkIfUserIsInAudience(e, y.key, Ye.RULE, r, n, "Everyone Else");

  if (o.push.apply(o, A.reasons), A.result) {
    var U = i.sprintf(we.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE, xe, r, "Everyone Else");

    if (this.logger.log(Ge.DEBUG, U), o.push(U), p = this.__buildBucketerParams(e, y.key, O, r), c = Ne.bucket(p), o.push.apply(o, c.reasons), I = c.result, _ = e.variationIdMap[I]) {
      var L = i.sprintf(we.USER_BUCKETED_INTO_EVERYONE_TARGETING_RULE, xe, r);
      return this.logger.log(Ge.DEBUG, L), o.push(L), {
        result: {
          experiment: y,
          variation: _,
          decisionSource: je.ROLLOUT
        },
        reasons: o
      };
    }

    var D = i.sprintf(we.USER_NOT_BUCKETED_INTO_EVERYONE_TARGETING_RULE, xe, r);
    this.logger.log(Ge.DEBUG, D), o.push(D);
  }

  return {
    result: {
      experiment: null,
      variation: null,
      decisionSource: je.ROLLOUT
    },
    reasons: o
  };
}, He.prototype._getBucketingId = function (e, t) {
  var r = e;
  return null != t && "object" == _typeof(t) && t.hasOwnProperty(p.BUCKETING_ID) && ("string" == typeof t[p.BUCKETING_ID] ? (r = t[p.BUCKETING_ID], this.logger.log(Ge.DEBUG, i.sprintf(we.VALID_BUCKETING_ID, xe, r))) : this.logger.log(Ge.WARNING, i.sprintf(we.BUCKETING_ID_NOT_STRING, xe))), r;
}, He.prototype.removeForcedVariation = function (e, t, r) {
  if (!e) throw new Error(i.sprintf(Ke.INVALID_USER_ID, xe));
  if (!this.forcedVariationMap.hasOwnProperty(e)) throw new Error(i.sprintf(Ke.USER_NOT_IN_FORCED_VARIATION, xe, e));
  delete this.forcedVariationMap[e][t], this.logger.log(Ge.DEBUG, i.sprintf(we.VARIATION_REMOVED_FOR_USER, xe, r, e));
}, He.prototype.__setInForcedVariationMap = function (e, t, r) {
  this.forcedVariationMap.hasOwnProperty(e) || (this.forcedVariationMap[e] = {}), this.forcedVariationMap[e][t] = r, this.logger.log(Ge.DEBUG, i.sprintf(we.USER_MAPPED_TO_FORCED_VARIATION, xe, r, t, e));
}, He.prototype.getForcedVariation = function (e, t, r) {
  var n,
      o = [],
      s = this.forcedVariationMap[r];
  if (!s) return this.logger.log(Ge.DEBUG, i.sprintf(we.USER_HAS_NO_FORCED_VARIATION, xe, r)), {
    result: null,
    reasons: o
  };

  try {
    var a = ne(e, t);

    if (!a.hasOwnProperty("id")) {
      var u = i.sprintf(Ke.IMPROPERLY_FORMATTED_EXPERIMENT, xe, t);
      return this.logger.log(Ge.ERROR, u), o.push(u), {
        result: null,
        reasons: o
      };
    }

    n = a.id;
  } catch (e) {
    return this.logger.log(Ge.ERROR, e.message), o.push(e.message), {
      result: null,
      reasons: o
    };
  }

  var l = s[n];
  if (!l) return this.logger.log(Ge.DEBUG, i.sprintf(we.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, xe, t, r)), {
    result: null,
    reasons: o
  };
  var E = re(e, l);

  if (E) {
    var f = i.sprintf(we.USER_HAS_FORCED_VARIATION, xe, E, t, r);
    this.logger.log(Ge.DEBUG, f), o.push(f);
  } else this.logger.log(Ge.DEBUG, i.sprintf(we.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, xe, t, r));

  return {
    result: E,
    reasons: o
  };
}, He.prototype.setForcedVariation = function (e, t, r, n) {
  if (null != n && !Be(n)) return this.logger.log(Ge.ERROR, i.sprintf(Ke.INVALID_VARIATION_KEY, xe)), !1;
  var o;

  try {
    var s = ne(e, t);
    if (!s.hasOwnProperty("id")) return this.logger.log(Ge.ERROR, i.sprintf(Ke.IMPROPERLY_FORMATTED_EXPERIMENT, xe, t)), !1;
    o = s.id;
  } catch (e) {
    return this.logger.log(Ge.ERROR, e.message), !1;
  }

  if (null == n) try {
    return this.removeForcedVariation(r, o, t, this.logger), !0;
  } catch (e) {
    return this.logger.log(Ge.ERROR, e.message), !1;
  }
  var a = ie(e, t, n);
  if (!a) return this.logger.log(Ge.ERROR, i.sprintf(Ke.NO_VARIATION_FOR_EXPERIMENT_KEY, xe, n, t)), !1;

  try {
    return this.__setInForcedVariationMap(r, o, a), !0;
  } catch (e) {
    return this.logger.log(Ge.ERROR, e.message), !1;
  }
};
var Xe = f.REVENUE,
    ze = f.VALUE;

function Je(e, t) {
  if (e.hasOwnProperty(Xe)) {
    var r = e[Xe],
        n = void 0;
    return "string" == typeof r ? (n = parseInt(r), isNaN(n) ? (t.log(u.INFO, i.sprintf(E.FAILED_TO_PARSE_REVENUE, "EVENT_TAG_UTILS", r)), null) : (t.log(u.INFO, i.sprintf(E.PARSED_REVENUE_VALUE, "EVENT_TAG_UTILS", n)), n)) : "number" == typeof r ? (n = r, t.log(u.INFO, i.sprintf(E.PARSED_REVENUE_VALUE, "EVENT_TAG_UTILS", n)), n) : null;
  }

  return null;
}

function Ze(e, t) {
  if (e.hasOwnProperty(ze)) {
    var r = e[ze],
        n = void 0;
    return "string" == typeof r ? (n = parseFloat(r), isNaN(n) ? (t.log(u.INFO, i.sprintf(E.FAILED_TO_PARSE_VALUE, "EVENT_TAG_UTILS", r)), null) : (t.log(u.INFO, i.sprintf(E.PARSED_NUMERIC_VALUE, "EVENT_TAG_UTILS", n)), n)) : "number" == typeof r ? (n = r, t.log(u.INFO, i.sprintf(E.PARSED_NUMERIC_VALUE, "EVENT_TAG_UTILS", n)), n) : null;
  }

  return null;
}

function We(e, t) {
  return "string" == typeof e && ("string" == typeof t || "boolean" == typeof t || F.isNumber(t) && F.isSafeInteger(t));
}

var qe = "https://logx.optimizely.com/v1/events";

function $e(e) {
  var t = e.attributes,
      r = e.configObj,
      i = r.anonymizeIP,
      n = r.botFiltering;
  null == i && (i = !1);
  var o = {
    snapshots: [],
    visitor_id: e.userId,
    attributes: []
  },
      s = {
    account_id: r.accountId,
    project_id: r.projectId,
    visitors: [o],
    revision: r.revision,
    client_name: e.clientEngine,
    client_version: e.clientVersion,
    anonymize_ip: i,
    enrich_decisions: !0
  };
  return Object.keys(t || {}).forEach(function (r) {
    if (We(r, t[r])) {
      var i = $(e.configObj, r, e.logger);
      i && s.visitors[0].attributes.push({
        entity_id: i,
        key: r,
        type: "custom",
        value: t[r]
      });
    }
  }), "boolean" == typeof n && s.visitors[0].attributes.push({
    entity_id: p.BOT_FILTERING,
    key: p.BOT_FILTERING,
    type: "custom",
    value: n
  }), s;
}

var Qe = function Qe(e) {
  var t = {
    httpVerb: "POST"
  },
      r = $e(e);
  t.url = qe;

  var i = function (e, t, r, i, n, o, s) {
    var a = null;
    null !== t && (a = q(e, t));
    var u = re(e, r);
    return null === u && (u = ""), {
      decisions: [{
        campaign_id: a,
        experiment_id: t,
        variation_id: r,
        metadata: {
          flag_key: o,
          rule_key: i,
          rule_type: n,
          variation_key: u,
          enabled: s
        }
      }],
      events: [{
        entity_id: a,
        timestamp: F.currentTimestamp(),
        key: "campaign_activated",
        uuid: F.uuid()
      }]
    };
  }(e.configObj, e.experimentId, e.variationId, e.ruleKey, e.ruleType, e.flagKey, e.enabled);

  return r.visitors[0].snapshots.push(i), t.params = r, t;
},
    et = function et(e) {
  var t = {
    httpVerb: "POST"
  },
      r = $e(e);
  t.url = qe;

  var i = function (e, t, r, i) {
    var n = {
      events: []
    },
        o = {
      entity_id: Q(e, t),
      timestamp: F.currentTimestamp(),
      uuid: F.uuid(),
      key: t
    };

    if (r) {
      var s = Je(r, i);
      null !== s && (o[f.REVENUE] = s);
      var a = Ze(r, i);
      null !== a && (o[f.VALUE] = a), o.tags = r;
    }

    return n.events.push(o), n;
  }(e.configObj, e.eventKey, e.eventTags, e.logger);

  return r.visitors[0].snapshots = [i], t.params = r, t;
};

function tt(e) {
  var t, r;
  return null !== (r = null === (t = e.experiment) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}

function rt(e) {
  var t, r;
  return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}

function it(e) {
  var t, r;
  return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.featureEnabled) && void 0 !== r && r;
}

var nt = t.getLogger("EVENT_BUILDER");

function ot(e, t) {
  var r = [];
  return Object.keys(t || {}).forEach(function (i) {
    if (We(i, t[i])) {
      var n = $(e, i, nt);
      n && r.push({
        entityId: n,
        key: i,
        value: t[i]
      });
    }
  }), r;
}

var st = {
  createEventProcessor: function createEventProcessor() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return new (r.LogTierV1EventProcessor.bind.apply(r.LogTierV1EventProcessor, a([void 0], e)))();
  },
  LocalStoragePendingEventsDispatcher: r.LocalStoragePendingEventsDispatcher
};
var at = "USER_PROFILE_SERVICE_VALIDATOR";

var ut = function () {
  function e(e) {
    var t,
        r = this,
        n = e.clientEngine;
    -1 === I.indexOf(n) && (e.logger.log(u.INFO, i.sprintf(E.INVALID_CLIENT_ENGINE, "OPTIMIZELY", n)), n = "node-sdk"), this.clientEngine = n, this.clientVersion = e.clientVersion || "4.5.1", this.errorHandler = e.errorHandler, this.eventDispatcher = e.eventDispatcher, this.isOptimizelyConfigValid = e.isValidInstance, this.logger = e.logger;
    var o = null !== (t = e.defaultDecideOptions) && void 0 !== t ? t : [];
    Array.isArray(o) || (this.logger.log(u.DEBUG, i.sprintf(E.INVALID_DEFAULT_DECIDE_OPTIONS, "OPTIMIZELY")), o = []);
    var s = {};
    o.forEach(function (e) {
      exports.OptimizelyDecideOption[e] ? s[e] = !0 : r.logger.log(u.WARNING, i.sprintf(E.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e));
    }), this.defaultDecideOptions = s, this.projectConfigManager = function (e) {
      return new Ie(e);
    }({
      datafile: e.datafile,
      datafileOptions: e.datafileOptions,
      jsonSchemaValidator: e.jsonSchemaValidator,
      sdkKey: e.sdkKey
    }), this.disposeOnUpdate = this.projectConfigManager.onUpdate(function (e) {
      r.logger.log(u.INFO, i.sprintf(E.UPDATED_OPTIMIZELY_CONFIG, "OPTIMIZELY", e.revision, e.projectId)), r.notificationCenter.sendNotifications(_.OPTIMIZELY_CONFIG_UPDATE);
    });
    var a = this.projectConfigManager.onReady(),
        f = null;
    if (e.userProfileService) try {
      (function (e) {
        if ("object" == _typeof(e) && null !== e) {
          if ("function" != typeof e.lookup) throw new Error(i.sprintf(l.INVALID_USER_PROFILE_SERVICE, at, "Missing function 'lookup'"));
          if ("function" != typeof e.save) throw new Error(i.sprintf(l.INVALID_USER_PROFILE_SERVICE, at, "Missing function 'save'"));
          return !0;
        }

        throw new Error(i.sprintf(l.INVALID_USER_PROFILE_SERVICE, at));
      })(e.userProfileService) && (f = e.userProfileService, this.logger.log(u.INFO, i.sprintf(E.VALID_USER_PROFILE_SERVICE, "OPTIMIZELY")));
    } catch (e) {
      this.logger.log(u.WARNING, e.message);
    }
    this.decisionService = new He({
      userProfileService: f,
      logger: this.logger,
      UNSTABLE_conditionEvaluators: e.UNSTABLE_conditionEvaluators
    }), this.notificationCenter = function (e) {
      return new _e(e);
    }({
      logger: this.logger,
      errorHandler: this.errorHandler
    });
    var p = {
      dispatcher: this.eventDispatcher,
      flushInterval: e.eventFlushInterval,
      batchSize: e.eventBatchSize,
      maxQueueSize: e.eventMaxQueueSize,
      notificationCenter: this.notificationCenter
    };
    this.eventProcessor = st.createEventProcessor(p);
    var g = this.eventProcessor.start();
    this.readyPromise = Promise.all([a, g]).then(function (e) {
      return e[0];
    }), this.readyTimeouts = {}, this.nextReadyTimeoutId = 0;
  }

  return e.prototype.isValidInstance = function () {
    return this.isOptimizelyConfigValid && !!this.projectConfigManager.getConfig();
  }, e.prototype.activate = function (e, t, r) {
    try {
      if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "activate")), null;
      if (!this.validateInputs({
        experiment_key: e,
        user_id: t
      }, r)) return this.notActivatingExperiment(e, t);
      var n = this.projectConfigManager.getConfig();
      if (!n) return null;

      try {
        var o = this.getVariation(e, t, r);
        if (null === o) return this.notActivatingExperiment(e, t);

        if (!K(n, e)) {
          var s = i.sprintf(E.SHOULD_NOT_DISPATCH_ACTIVATE, "OPTIMIZELY", e);
          return this.logger.log(u.DEBUG, s), o;
        }

        var a = w(n, e),
            l = {
          experiment: a,
          variation: a.variationKeyMap[o],
          decisionSource: c.EXPERIMENT
        };
        return this.sendImpressionEvent(l, "", t, !0, r), o;
      } catch (r) {
        this.logger.log(u.ERROR, r.message);
        var f = i.sprintf(E.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e);
        return this.logger.log(u.INFO, f), this.errorHandler.handleError(r), null;
      }
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.sendImpressionEvent = function (e, t, r, i, n) {
    var o = this.projectConfigManager.getConfig();

    if (o) {
      var s = function (e) {
        var t = e.configObj,
            r = e.decisionObj,
            i = e.userId,
            n = e.flagKey,
            o = e.enabled,
            s = e.userAttributes,
            a = e.clientEngine,
            u = e.clientVersion,
            l = r.decisionSource,
            E = tt(r),
            f = rt(r),
            p = null,
            I = null;
        "" !== E && "" !== f && (I = ie(t, E, f)), "" !== E && (p = W(t, E));
        var _ = null;
        return null !== p && (_ = q(t, p)), {
          type: "impression",
          timestamp: F.currentTimestamp(),
          uuid: F.uuid(),
          user: {
            id: i,
            attributes: ot(t, s)
          },
          context: {
            accountId: t.accountId,
            projectId: t.projectId,
            revision: t.revision,
            clientName: a,
            clientVersion: u,
            anonymizeIP: t.anonymizeIP || !1,
            botFiltering: t.botFiltering
          },
          layer: {
            id: _
          },
          experiment: {
            id: p,
            key: E
          },
          variation: {
            id: I,
            key: f
          },
          ruleKey: E,
          flagKey: n,
          ruleType: l,
          enabled: o
        };
      }({
        decisionObj: e,
        flagKey: t,
        enabled: i,
        userId: r,
        userAttributes: n,
        clientEngine: this.clientEngine,
        clientVersion: this.clientVersion,
        configObj: o
      });

      this.eventProcessor.process(s), this.emitNotificationCenterActivate(e, t, r, i, n);
    }
  }, e.prototype.emitNotificationCenterActivate = function (e, t, r, i, n) {
    var o = this.projectConfigManager.getConfig();

    if (o) {
      var s = e.decisionSource,
          a = tt(e),
          u = rt(e),
          l = null,
          E = null;
      "" !== a && "" !== u && (E = G(o, a, u), l = B(o, a));
      var f,
          p = {
        attributes: n,
        clientEngine: this.clientEngine,
        clientVersion: this.clientVersion,
        configObj: o,
        experimentId: l,
        ruleKey: a,
        flagKey: t,
        ruleType: s,
        userId: r,
        enabled: i,
        variationId: E,
        logger: this.logger
      },
          I = Qe(p),
          g = o.experimentKeyMap[a];
      g && g.variationKeyMap && "" !== u && (f = g.variationKeyMap[u]), this.notificationCenter.sendNotifications(_.ACTIVATE, {
        experiment: g,
        userId: r,
        attributes: n,
        variation: f,
        logEvent: I
      });
    }
  }, e.prototype.track = function (e, t, r, n) {
    try {
      if (!this.isValidInstance()) return void this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "track"));
      if (!this.validateInputs({
        user_id: t,
        event_key: e
      }, r, n)) return;
      var o = this.projectConfigManager.getConfig();
      if (!o) return;
      if (!z(o, e)) return this.logger.log(u.WARNING, i.sprintf(E.EVENT_KEY_NOT_FOUND, "OPTIMIZELY", e)), void this.logger.log(u.WARNING, i.sprintf(E.NOT_TRACKING_USER, "OPTIMIZELY", t));

      var s = function (e) {
        var t = e.configObj,
            r = e.userId,
            i = e.userAttributes,
            n = e.clientEngine,
            o = e.clientVersion,
            s = e.eventKey,
            a = e.eventTags,
            u = Q(t, s),
            l = null,
            E = null;
        return a && (l = Je(a, nt), E = Ze(a, nt)), {
          type: "conversion",
          timestamp: F.currentTimestamp(),
          uuid: F.uuid(),
          user: {
            id: r,
            attributes: ot(t, i)
          },
          context: {
            accountId: t.accountId,
            projectId: t.projectId,
            revision: t.revision,
            clientName: n,
            clientVersion: o,
            anonymizeIP: t.anonymizeIP || !1,
            botFiltering: t.botFiltering
          },
          event: {
            id: u,
            key: s
          },
          revenue: l,
          value: E,
          tags: a
        };
      }({
        eventKey: e,
        eventTags: n = this.filterEmptyValues(n),
        userId: t,
        userAttributes: r,
        clientEngine: this.clientEngine,
        clientVersion: this.clientVersion,
        configObj: o
      });

      this.logger.log(u.INFO, i.sprintf(E.TRACK_EVENT, "OPTIMIZELY", e, t)), this.eventProcessor.process(s), this.emitNotificationCenterTrack(e, t, r, n);
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
      var a = i.sprintf(E.NOT_TRACKING_USER, "OPTIMIZELY", t);
      this.logger.log(u.ERROR, a);
    }
  }, e.prototype.emitNotificationCenterTrack = function (e, t, r, i) {
    try {
      var n = this.projectConfigManager.getConfig();
      if (!n) return;
      var o = {
        attributes: r,
        clientEngine: this.clientEngine,
        clientVersion: this.clientVersion,
        configObj: n,
        eventKey: e,
        eventTags: i,
        logger: this.logger,
        userId: t
      },
          s = et(o);
      this.notificationCenter.sendNotifications(_.TRACK, {
        eventKey: e,
        userId: t,
        attributes: r,
        eventTags: i,
        logEvent: s
      });
    } catch (e) {
      this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e);
    }
  }, e.prototype.getVariation = function (e, t, r) {
    try {
      if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getVariation")), null;

      try {
        if (!this.validateInputs({
          experiment_key: e,
          user_id: t
        }, r)) return null;
        var n = this.projectConfigManager.getConfig();
        if (!n) return null;
        var o = n.experimentKeyMap[e];
        if (!o) return this.logger.log(u.DEBUG, i.sprintf(l.INVALID_EXPERIMENT_KEY, "OPTIMIZELY", e)), null;
        var s = this.decisionService.getVariation(n, e, t, r).result,
            a = J(n, o.id) ? g.FEATURE_TEST : g.AB_TEST;
        return this.notificationCenter.sendNotifications(_.DECISION, {
          type: a,
          userId: t,
          attributes: r || {},
          decisionInfo: {
            experimentKey: e,
            variationKey: s
          }
        }), s;
      } catch (e) {
        return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.setForcedVariation = function (e, t, r) {
    if (!this.validateInputs({
      experiment_key: e,
      user_id: t
    })) return !1;
    var i = this.projectConfigManager.getConfig();
    if (!i) return !1;

    try {
      return this.decisionService.setForcedVariation(i, e, t, r);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), !1;
    }
  }, e.prototype.getForcedVariation = function (e, t) {
    if (!this.validateInputs({
      experiment_key: e,
      user_id: t
    })) return null;
    var r = this.projectConfigManager.getConfig();
    if (!r) return null;

    try {
      return this.decisionService.getForcedVariation(r, e, t).result;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.validateInputs = function (e, t, r) {
    try {
      if (e.hasOwnProperty("user_id")) {
        var n = e.user_id;
        if ("string" != typeof n || null === n || "undefined" === n) throw new Error(i.sprintf(l.INVALID_INPUT_FORMAT, "OPTIMIZELY", "user_id"));
        delete e.user_id;
      }

      return Object.keys(e).forEach(function (t) {
        if (!Be(e[t])) throw new Error(i.sprintf(l.INVALID_INPUT_FORMAT, "OPTIMIZELY", t));
      }), t && function (e) {
        if ("object" != _typeof(e) || Array.isArray(e) || null === e) throw new Error(i.sprintf(l.INVALID_ATTRIBUTES, "ATTRIBUTES_VALIDATOR"));
        Object.keys(e).forEach(function (t) {
          if (void 0 === e[t]) throw new Error(i.sprintf(l.UNDEFINED_ATTRIBUTE, "ATTRIBUTES_VALIDATOR", t));
        });
      }(t), r && function (e) {
        if ("object" != _typeof(e) || Array.isArray(e) || null === e) throw new Error(i.sprintf(l.INVALID_EVENT_TAGS, "EVENT_TAGS_VALIDATOR"));
      }(r), !0;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), !1;
    }
  }, e.prototype.notActivatingExperiment = function (e, t) {
    var r = i.sprintf(E.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e);
    return this.logger.log(u.INFO, r), null;
  }, e.prototype.filterEmptyValues = function (e) {
    for (var t in e) {
      !e.hasOwnProperty(t) || null !== e[t] && void 0 !== e[t] || delete e[t];
    }

    return e;
  }, e.prototype.isFeatureEnabled = function (e, t, r) {
    try {
      if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "isFeatureEnabled")), !1;
      if (!this.validateInputs({
        feature_key: e,
        user_id: t
      }, r)) return !1;
      var n = this.projectConfigManager.getConfig();
      if (!n) return !1;
      var o = j(n, e, this.logger);
      if (!o) return !1;
      var s = {},
          a = this.decisionService.getVariationForFeature(n, o, t, r).result,
          l = a.decisionSource,
          f = tt(a),
          p = rt(a),
          I = it(a);
      l === c.FEATURE_TEST && (s = {
        experimentKey: f,
        variationKey: p
      }), (l === c.FEATURE_TEST || l === c.ROLLOUT && Z(n)) && this.sendImpressionEvent(a, o.key, t, I, r), !0 === I ? this.logger.log(u.INFO, i.sprintf(E.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", e, t)) : (this.logger.log(u.INFO, i.sprintf(E.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", e, t)), I = !1);
      var d = {
        featureKey: e,
        featureEnabled: I,
        source: a.decisionSource,
        sourceInfo: s
      };
      return this.notificationCenter.sendNotifications(_.DECISION, {
        type: g.FEATURE,
        userId: t,
        attributes: r || {},
        decisionInfo: d
      }), I;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), !1;
    }
  }, e.prototype.getEnabledFeatures = function (e, t) {
    var r = this;

    try {
      var n = [];
      if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getEnabledFeatures")), n;
      if (!this.validateInputs({
        user_id: e
      })) return n;
      var o = this.projectConfigManager.getConfig();
      return o ? (i.objectValues(o.featureKeyMap).forEach(function (i) {
        r.isFeatureEnabled(i.key, e, t) && n.push(i.key);
      }), n) : n;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), [];
    }
  }, e.prototype.getFeatureVariable = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, null, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariable")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getFeatureVariableForType = function (e, t, r, n, o) {
    if (!this.validateInputs({
      feature_key: e,
      variable_key: t,
      user_id: n
    }, o)) return null;
    var s = this.projectConfigManager.getConfig();
    if (!s) return null;
    var a = j(s, e, this.logger);
    if (!a) return null;
    var l = Y(s, e, t, this.logger);
    if (!l) return null;
    if (r && l.type !== r) return this.logger.log(u.WARNING, i.sprintf(E.VARIABLE_REQUESTED_WITH_WRONG_TYPE, "OPTIMIZELY", r, l.type)), null;
    var f = this.decisionService.getVariationForFeature(s, a, n, o).result,
        p = it(f),
        I = this.getFeatureVariableValueFromVariation(e, p, f.variation, l, n),
        d = {};
    return f.decisionSource === c.FEATURE_TEST && null !== f.experiment && null !== f.variation && (d = {
      experimentKey: f.experiment.key,
      variationKey: f.variation.key
    }), this.notificationCenter.sendNotifications(_.DECISION, {
      type: g.FEATURE_VARIABLE,
      userId: n,
      attributes: o || {},
      decisionInfo: {
        featureKey: e,
        featureEnabled: p,
        source: f.decisionSource,
        variableKey: t,
        variableValue: I,
        variableType: l.type,
        sourceInfo: d
      }
    }), I;
  }, e.prototype.getFeatureVariableValueFromVariation = function (e, t, r, n, o) {
    var s = this.projectConfigManager.getConfig();
    if (!s) return null;
    var a = n.defaultValue;

    if (null !== r) {
      var l = H(s, n, r, this.logger);
      null !== l ? t ? (a = l, this.logger.log(u.INFO, i.sprintf(E.USER_RECEIVED_VARIABLE_VALUE, "OPTIMIZELY", a, n.key, e))) : this.logger.log(u.INFO, i.sprintf(E.FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", e, o, a)) : this.logger.log(u.INFO, i.sprintf(E.VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", n.key, r.key));
    } else this.logger.log(u.INFO, i.sprintf(E.USER_RECEIVED_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", o, n.key, e));

    return X(a, n.type, this.logger);
  }, e.prototype.getFeatureVariableBoolean = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, O.BOOLEAN, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableBoolean")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getFeatureVariableDouble = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, O.DOUBLE, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableDouble")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getFeatureVariableInteger = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, O.INTEGER, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableInteger")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getFeatureVariableString = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, O.STRING, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableString")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getFeatureVariableJSON = function (e, t, r, n) {
    try {
      return this.isValidInstance() ? this.getFeatureVariableForType(e, t, O.JSON, r, n) : (this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableJSON")), null);
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getAllFeatureVariables = function (e, t, r) {
    var n = this;

    try {
      if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "getAllFeatureVariables")), null;
      if (!this.validateInputs({
        feature_key: e,
        user_id: t
      }, r)) return null;
      var o = this.projectConfigManager.getConfig();
      if (!o) return null;
      var s = j(o, e, this.logger);
      if (!s) return null;
      var a = this.decisionService.getVariationForFeature(o, s, t, r).result,
          l = it(a),
          f = {};
      s.variables.forEach(function (r) {
        f[r.key] = n.getFeatureVariableValueFromVariation(e, l, a.variation, r, t);
      });
      var p = {};
      return a.decisionSource === c.FEATURE_TEST && null !== a.experiment && null !== a.variation && (p = {
        experimentKey: a.experiment.key,
        variationKey: a.variation.key
      }), this.notificationCenter.sendNotifications(_.DECISION, {
        type: g.ALL_FEATURE_VARIABLES,
        userId: t,
        attributes: r || {},
        decisionInfo: {
          featureKey: e,
          featureEnabled: l,
          source: a.decisionSource,
          variableValues: f,
          sourceInfo: p
        }
      }), f;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.getOptimizelyConfig = function () {
    try {
      return this.projectConfigManager.getConfig() ? this.projectConfigManager.getOptimizelyConfig() : null;
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), null;
    }
  }, e.prototype.close = function () {
    var e = this;

    try {
      var t = this.eventProcessor.stop();
      return this.disposeOnUpdate && (this.disposeOnUpdate(), this.disposeOnUpdate = null), this.projectConfigManager && this.projectConfigManager.stop(), Object.keys(this.readyTimeouts).forEach(function (t) {
        var r = e.readyTimeouts[t];
        clearTimeout(r.readyTimeout), r.onClose();
      }), this.readyTimeouts = {}, t.then(function () {
        return {
          success: !0
        };
      }, function (e) {
        return {
          success: !1,
          reason: String(e)
        };
      });
    } catch (e) {
      return this.logger.log(u.ERROR, e.message), this.errorHandler.handleError(e), Promise.resolve({
        success: !1,
        reason: String(e)
      });
    }
  }, e.prototype.onReady = function (e) {
    var t,
        r,
        n = this;
    "object" == _typeof(e) && null !== e && void 0 !== e.timeout && (t = e.timeout), F.isSafeInteger(t) || (t = 3e4);
    var o = new Promise(function (e) {
      r = e;
    }),
        s = this.nextReadyTimeoutId;
    this.nextReadyTimeoutId++;
    var a = setTimeout(function () {
      delete n.readyTimeouts[s], r({
        success: !1,
        reason: i.sprintf("onReady timeout expired after %s ms", t)
      });
    }, t);
    return this.readyTimeouts[s] = {
      readyTimeout: a,
      onClose: function onClose() {
        r({
          success: !1,
          reason: "Instance closed"
        });
      }
    }, this.readyPromise.then(function () {
      clearTimeout(a), delete n.readyTimeouts[s], r({
        success: !0
      });
    }), Promise.race([this.readyPromise, o]);
  }, e.prototype.createUserContext = function (e, t) {
    return this.validateInputs({
      user_id: e
    }, t) ? new P({
      optimizely: this,
      userId: e,
      attributes: t
    }) : null;
  }, e.prototype.decide = function (e, t, r) {
    var n,
        o,
        s,
        a,
        f = this;
    void 0 === r && (r = []);
    var p = this.projectConfigManager.getConfig(),
        I = [];
    if (!this.isValidInstance() || !p) return I.push(R.SDK_NOT_READY), this.logger.log(u.INFO, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "decide")), C(t, e, I);
    var d = p.featureKeyMap[t];
    if (!d) return I.push(i.sprintf(R.FLAG_KEY_INVALID, t)), this.logger.log(u.ERROR, i.sprintf(l.FEATURE_NOT_IN_DATAFILE, "OPTIMIZELY", t)), C(t, e, I);
    var O = e.getUserId(),
        N = e.getAttributes(),
        v = this.getAllDecideOptions(r),
        h = this.decisionService.getVariationForFeature(p, d, O, N, v);
    I.push.apply(I, h.reasons);
    var T = h.result,
        y = T.decisionSource,
        A = null !== (o = null === (n = T.experiment) || void 0 === n ? void 0 : n.key) && void 0 !== o ? o : null,
        U = null !== (a = null === (s = T.variation) || void 0 === s ? void 0 : s.key) && void 0 !== a ? a : null,
        L = it(T);
    !0 === L ? this.logger.log(u.INFO, i.sprintf(E.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", t, O)) : this.logger.log(u.INFO, i.sprintf(E.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", t, O));
    var D = {},
        S = !1;
    v[exports.OptimizelyDecideOption.EXCLUDE_VARIABLES] || d.variables.forEach(function (e) {
      D[e.key] = f.getFeatureVariableValueFromVariation(t, L, T.variation, e, O);
    }), !v[exports.OptimizelyDecideOption.DISABLE_DECISION_EVENT] && (y === c.FEATURE_TEST || y === c.ROLLOUT && Z(p)) && (this.sendImpressionEvent(T, t, O, L, N), S = !0);
    var m = v[exports.OptimizelyDecideOption.INCLUDE_REASONS] ? I : [],
        V = {
      flagKey: t,
      enabled: L,
      variationKey: U,
      ruleKey: A,
      variables: D,
      reasons: m,
      decisionEventDispatched: S
    };
    return this.notificationCenter.sendNotifications(_.DECISION, {
      type: g.FLAG,
      userId: O,
      attributes: N,
      decisionInfo: V
    }), {
      variationKey: U,
      enabled: L,
      variables: D,
      ruleKey: A,
      flagKey: t,
      userContext: e,
      reasons: m
    };
  }, e.prototype.getAllDecideOptions = function (e) {
    var t = this,
        r = _s({}, this.defaultDecideOptions);

    return Array.isArray(e) ? e.forEach(function (e) {
      exports.OptimizelyDecideOption[e] ? r[e] = !0 : t.logger.log(u.WARNING, i.sprintf(E.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e));
    }) : this.logger.log(u.DEBUG, i.sprintf(E.INVALID_DECIDE_OPTIONS, "OPTIMIZELY")), r;
  }, e.prototype.decideForKeys = function (e, t, r) {
    var n = this;
    void 0 === r && (r = []);
    var o = {};
    if (!this.isValidInstance()) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "decideForKeys")), o;
    if (0 === t.length) return o;
    var s = this.getAllDecideOptions(r);
    return t.forEach(function (t) {
      var i = n.decide(e, t, r);
      s[exports.OptimizelyDecideOption.ENABLED_FLAGS_ONLY] && !i.enabled || (o[t] = i);
    }), o;
  }, e.prototype.decideAll = function (e, t) {
    void 0 === t && (t = []);
    var r = this.projectConfigManager.getConfig();
    if (!this.isValidInstance() || !r) return this.logger.log(u.ERROR, i.sprintf(E.INVALID_OBJECT, "OPTIMIZELY", "decideAll")), {};
    var n = Object.keys(r.featureKeyMap);
    return this.decideForKeys(e, n, t);
  }, e;
}(),
    lt = function lt(e) {
  return !("number" != typeof e || !F.isSafeInteger(e)) && e >= 1;
},
    Et = function Et(e) {
  return !("number" != typeof e || !F.isSafeInteger(e)) && e > 0;
},
    ft = t.getLogger();

t.setLogHandler(V.createLogger()), t.setLogLevel(t.LogLevel.INFO);

var pt = !1,
    It = function It(e) {
  try {
    e.errorHandler && t.setErrorHandler(e.errorHandler), e.logger && (t.setLogHandler(e.logger), t.setLogLevel(t.LogLevel.NOTSET)), void 0 !== e.logLevel && t.setLogLevel(e.logLevel);

    try {
      y(e), e.isValidInstance = !0;
    } catch (t) {
      ft.error(t), e.isValidInstance = !1;
    }

    var i = void 0;
    null == e.eventDispatcher ? (i = new r.LocalStoragePendingEventsDispatcher({
      eventDispatcher: D
    }), pt || (i.sendPendingEvents(), pt = !0)) : i = e.eventDispatcher;
    var n = e.eventBatchSize,
        o = e.eventFlushInterval;
    lt(e.eventBatchSize) || (ft.warn("Invalid eventBatchSize %s, defaulting to %s", e.eventBatchSize, 10), n = 10), Et(e.eventFlushInterval) || (ft.warn("Invalid eventFlushInterval %s, defaulting to %s", e.eventFlushInterval, 1e3), o = 1e3);

    var a = _s(_s({
      clientEngine: "javascript-sdk",
      eventDispatcher: i
    }, e), {
      eventBatchSize: n,
      eventFlushInterval: o,
      logger: ft,
      errorHandler: t.getErrorHandler()
    }),
        u = new ut(a);

    try {
      if ("function" == typeof window.addEventListener) {
        var l = "onpagehide" in window ? "pagehide" : "unload";
        window.addEventListener(l, function () {
          u.close();
        }, !1);
      }
    } catch (e) {
      ft.error(E.UNABLE_TO_ATTACH_UNLOAD, "INDEX_BROWSER", e.message);
    }

    return u;
  } catch (e) {
    return ft.error(e), null;
  }
},
    _t = function _t() {
  pt = !1;
},
    gt = {
  logging: V,
  errorHandler: U,
  eventDispatcher: D,
  enums: v,
  setLogger: t.setLogHandler,
  setLogLevel: t.setLogLevel,
  createInstance: It,
  __internalResetRetryState: _t,
  OptimizelyDecideOption: exports.OptimizelyDecideOption
};

Object.defineProperty(exports, "setLogLevel", {
  enumerable: !0,
  get: function get() {
    return t.setLogLevel;
  }
}), Object.defineProperty(exports, "setLogger", {
  enumerable: !0,
  get: function get() {
    return t.setLogHandler;
  }
}), exports.__internalResetRetryState = _t, exports.createInstance = It, exports.default = gt, exports.enums = v, exports.errorHandler = U, exports.eventDispatcher = D, exports.logging = V;